var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Banner/index.tsx";
import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
const Banner = ({
  message,
  submessage,
  ...rest
}) => {
  if (!message && !submessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(VStack, Object.assign({
    background: "$surface.container",
    display: "flex",
    flexDirection: "row",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "$neutral.20",
    borderLeftWidth: 0,
    borderRightWidth: 0,
    padding: "$4",
    marginBottom: "$2",
    marginTop: "$3",
    testID: "Banner.wrapper"
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconValidationInvalid, {
    color: "$support.danger.surfaceOnColorAlt",
    testID: "Banner.iconError",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(VStack, {
    marginLeft: "$2",
    display: "flex",
    flex: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "Banner.message",
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }, message), /*#__PURE__*/React.createElement(Text, {
    testID: "Banner.message2",
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, submessage)));
};
export { Banner };